import { Link } from 'react-router-dom';

export interface BreadcrumbItem {
  label: string;
  /** Si falta, el crumb es texto (nivel actual o hint de clínica). */
  to?: string;
  testId?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  label: string;
}

/**
 * Trail de contexto: Red/casa → clínica (opcional) → dominio → detalle.
 * Una sola línea: nombres largos se truncan (mobile + dark).
 */
export function Breadcrumbs({ items, label }: BreadcrumbsProps) {
  const visible = items.filter((item) => item.label.trim().length > 0);
  if (visible.length === 0) return null;

  return (
    <nav aria-label={label} className="min-w-0" data-testid="context-breadcrumbs">
      <ol className="flex min-w-0 flex-nowrap items-center gap-1.5 overflow-hidden text-sm text-slate-500 dark:text-slate-400">
        {visible.map((item, index) => {
          const isLast = index === visible.length - 1;
          const maxClass = isLast
            ? 'min-w-0 max-w-[min(100%,16rem)] sm:max-w-xs'
            : 'min-w-0 max-w-[28vw] sm:max-w-[10rem]';
          const content =
            item.to && !isLast ? (
              <Link
                to={item.to}
                title={item.label}
                data-testid={item.testId}
                className={`${maxClass} truncate font-semibold text-teal-700 hover:text-teal-800 dark:text-teal-300 dark:hover:text-teal-200`}
              >
                {item.label}
              </Link>
            ) : (
              <span
                title={item.label}
                data-testid={item.testId}
                aria-current={isLast ? 'page' : undefined}
                className={`${maxClass} truncate text-slate-700 dark:text-slate-200`}
              >
                {item.label}
              </span>
            );

          return (
            <li key={`${item.label}-${index}`} className="flex min-w-0 items-center gap-1.5">
              {index > 0 ? <span aria-hidden="true">/</span> : null}
              {content}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
